import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import styles from "./about-article-section.module.css";
import { FixaListView } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListView";
import { StockStatus } from "./StockStatus/StockStatus";
import { NextDelivery } from "./NextDelivery/NextDelivery";
import { SupplierNumber } from "./SupplierNumber/SupplierNumber";
import { DateStamp } from "./DateStamp/DateStamp";
import { ItemNoAndType } from "@coworker/apprestructured/src/shared/types/item";

interface AboutArticleSectionProps {
  itemNoAndType: ItemNoAndType;
}

export const AboutArticleSection = ({
  itemNoAndType,
}: AboutArticleSectionProps) => {
  return (
    <>
      <div className={styles["about-article-title"]}>
        <FixaText textStyle="Body.S">About article</FixaText>
      </div>
      <FixaListView id="about-article-list">
        <StockStatus itemNoAndType={itemNoAndType} />
        <NextDelivery itemNo={itemNoAndType.no} />
        <SupplierNumber />
        <DateStamp />
      </FixaListView>
    </>
  );
};
